module.exports = __webpack_public_path__ + "static/media/weetameal.202af9a6.png";